import { Icon } from '@mui/material';
import VesisTextIcon from 'src/resources/icons/vesisTextIcon';
import { styled } from '@mui/material/styles';

export const StyledVesisIcon = styled(VesisTextIcon)(({ theme }) => ({
    height: 40, // Default height
    width: 184, // Default width
    [theme.breakpoints.up('xxl')]: {
        height: 120,
        width: 450, // Increased size for XXL screens
    },
}));

export const StyledSocialIcon = styled(Icon)(({ theme }) => ({
    fontSize: '1.5rem',
    [theme.breakpoints.up('xxl')]: {
        fontSize: '3rem',
    },
}));

export const StyledExpertiseIcon = styled(Icon)(({ theme }) => ({
    // height: 28, // Default height
    // width: 19, // Default width
    [theme.breakpoints.up('xxl')]: {
        height: 128,
        width: 98, // Increased size for XXL screens
    },
}));
